import appCustomers from "../../views/appCustomers/index.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "customers";
  const params = [
    "page",
    "limit",
    "active",
    "role",
    "user",
    "search",
    "sort",
    "corporate",
  ];

  $stateProvider.state("customers", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCustomers,
      },
    },
    reloadOnSearch: false,
    data: { title: "Customers" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/customers/customers.urls.js